import { useColorMode, useStorage, useToggle } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'

/**
 * State UI global (client-side): sidebar & tema.
 * Catatan: server-state (data dari API) TIDAK disimpan di Pinia —
 * itu tanggung jawab TanStack Query. Pinia hanya untuk state UI murni.
 */
export const useUiStore = defineStore('ui', () => {
  // Dipersistensi: lebar sidebar adalah preferensi kerja, bukan state sesaat.
  // Kasir yang mengecilkannya untuk dapat ruang tabel tidak perlu
  // mengulanginya setiap kali halaman dimuat ulang.
  const sidebarCollapsed = useStorage('pos-sidebar-collapsed', false)
  const toggleSidebar = useToggle(sidebarCollapsed)

  // Default selalu TERANG dan tidak mengikuti preferensi sistem.
  // storageKey baru ('pos-theme') agar nilai lama ('auto') tidak terpakai.
  const colorMode = useColorMode({
    initialValue: 'light',
    storageKey: 'pos-theme',
    emitAuto: false,
  })
  const isDark = computed(() => colorMode.value === 'dark')
  function toggleTheme() {
    colorMode.value = isDark.value ? 'light' : 'dark'
  }

  return { sidebarCollapsed, toggleSidebar, colorMode, isDark, toggleTheme }
})
